import * as lazy from "./lazyRouteComponents";

export default [
  {
    path: "",
    name: "itrain:dashboard",
    component: lazy.DashboardIndex
  },
  //

  {
    path: "courses",
    name: "itrain:courseList",
    component: lazy.CourseList
  },
  {
    path: "courses/new",
    name: "itrain:courseCreate",
    component: lazy.CreateCourse
  },
  {
    path: "courses/:courseId/edit",
    name: "itrain:courseEdit",
    component: lazy.EditCourse
  },
  {
    path: "courses/:courseId/report",
    name: "itrain:courseReport",
    component: lazy.CourseReport
  },

  //

  {
    path: "programs",
    name: "itrain:programList",
    component: lazy.ProgramList
  },
  {
    path: "programs/new",
    name: "itrain:programCreate",
    component: lazy.CreateProgram
  },
  {
    path: "programs/:programId/edit",
    name: "itrain:programEdit",
    component: lazy.EditProgram
  },
  {
    path: "programs/:programId/report",
    name: "itrain:programReport",
    component: lazy.ProgramReport
  },

  // Notifications
  {
    path: "notifications",
    name: "itrain:notifications",
    component: lazy.NotificationSearch
  },

  // Reports

  {
    path: "reports/courses",
    name: "itrain:coursesReport",
    component: lazy.CoursesReport
  },
  {
    path: "reports/users",
    name: "itrain:usersReportList",
    component: lazy.UsersList
  },
  {
    path: "reports/users/:id",
    name: "itrain:usersReportDetail",
    component: lazy.UsersReport
  }
];
